'use strict';

const appSetup        = require('global/reactHelpers/appSetup.es');
const ContextProvider = require('global/reactHelpers/ContextProvider.es');
const pick            = require('lodash.pick');
const isEmpty         = require('lodash.isempty');

/**
 * Creates a Fluxible app, registers the specified stores with it,
 * and creates the context from the app, allowing the nav bar to continue initialization using that context.
 * If dehydrated state is passed in, rehydrates App and returns a promise.
 *
 * @param {Array} [stores=[]] - An array of stores that should be registered with the app.
 * @param {Object} [opt={}]
 * @param {boolean} [opt.connectToNavBar=true] - If true, register Nav Bar stores with the app
 * @param {Object} [opt.state={}] - Dehydrated state of server-side App
 * @returns {Object|Promise} - Returns Fluxible Context, or Promise that resolves to Fluxible Context
 */
function createEntryPointContext(stores = [], opt = {}) {
    const options = { connectToNavBar: true, state : {}, connectToContact: false };
    let App;
    let rehydrate;
    let promise;
    let context;

    Object.assign(options, opt);

    App        = appSetup(stores, pick(options, 'connectToNavBar', 'connectToContact', 'contactOptions'));
    context    = App.createContext();
    rehydrate  = options.state && !isEmpty(options.state);

    if (rehydrate) {
        promise = new Promise((resolve/*, reject*/) => {

            App.rehydrate(options.state, (error, rehydratedContext) => {
                if (error) {
                    console.log('Encontered an error while rehydrating App, ' +
                                    'but failing silently and allowing context to be set: ' + error + '\n' + error.stack);

                    // If rehydration fails fallback to context without rehydrating to prevent showing user blank page
                    rehydratedContext = context;
                }
                resolve(ContextProvider.setContext(rehydratedContext));
            });
        });
    }

    return rehydrate ? promise : ContextProvider.setContext(context);
}

module.exports = createEntryPointContext;



// WEBPACK FOOTER //
// ./assets/js/global/reactHelpers/createEntryPointContext.es.js